// Marker attribute placed on the filter popup root. The picker
// dropdowns walk up the DOM with `closest()` to find this element so
// they can cap their own height to the popup's — see
// `useFilterPopupHeight`. Defined as a constant so the writer
// (`TicketsSearchInputSection`) and reader (the hook) can't drift.
export const FILTER_POPUP_MARKER_ATTR = 'data-filter-popup';
